export const GAME_FLOW_FORWARD_DELAY_AFTER_FINISH_TRIALS = 900;
export const FISH_ANIMATION_TIME = 300;
export const FISH_ANIMATION_START_DELAY = 600;
export const GO_BOX_DISPLAY_START_DELAY = 600;
export const GO_BOX_DISPLAY_TIME = 1;
export const FEEDBACK_ICON_DISPLAY_TIME = 1000;
